import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, } from '@angular/common/http';
import { AppConfig } from '../../app-config';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { Action } from 'rxjs/internal/scheduler/Action';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    public schoolProps!: SchoolData;

    constructor(
        private httpClient: HttpClient,
        private apiUrl: AppConfig
    ) { }

    public teachersDashboardAPI = (): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teachersDashboardAPI);
    }
    public teachersDashboardBookingsAPI = (): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teachersDashboardBookingsAPI);
    }
    public nextPrevAPI = (date: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.nextPrevAPI, { date: date });
    }
    jobSaveUnsaveAPI = (jobId: any, action: string): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.jobSaveUnsaveAPI, { job_id: jobId, type: action });
    }
    getJobAlertAPI = (event: any, action: string): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.getJobAlertAPI, { email_job_alert_near: event, action: action });
    }
    // public removeSchoolAPI = (schoolID: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.removeSchoolAPI, schoolID);
    // }
    // public getTeacherAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getTeacherAPI, { params: filterData });
    // }
    // public removeTeacherAPI = (teacherID: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.removeTeacherAPI, teacherID);
    // }
    // public WaggaupdateValidationAPI = (requestData: any, teacherID: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.WaggaupdateValidationAPI + teacherID + '/', requestData);
    // }
    // public BceupdateValidationAPI = (requestData: any, teacherID: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.BceupdateValidationAPI + teacherID + '/', requestData);
    // }

    // public getLappsedAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getLappsedAPI, { params: filterData });
    // }
    // public getLappsedApprovedAPI = (requestData: any,): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.getLappsedApprovedAPI, requestData);
    // }


    // public getBookingsReportAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getBookingsReportAPI, { params: filterData });
    // }
    // public getBookingsDownloadReportAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.getBookingsReportAPI, requestData);
    // }

    // public getCustomFieldAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getCustomFieldAPI, { params: filterData });
    // }

    // public bookingsReportPageAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.bookingsReportPageAPI, { params: requestData });
    // }
    // public bookingsPreConfirmReportPageAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.bookingsPreConfirmReportPageAPI, { params: requestData });
    // }
    // public validatedTeachersGraphAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.validatedTeachersGraphAPI, { params: requestData });
    // }
    // public schoolEducatorsGraphAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.schoolEducatorsGraphAPI, { params: requestData });
    // }
    // public schoolListGraphAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.schoolListGraphAPI, { params: requestData });
    // }

    // public pendingInviteAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.pendingInviteAPI, { params: filterData });
    // }
    // public pendingRequestAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.pendingRequestAPI, { params: filterData });
    // }
    // public personalInfoAPI = (): Observable<any> => {
    //     return this.httpClient.get<any>(this.apiUrl.groupApiUrl.personalInfoAPI);
    // }
    // personalInfoUpdateAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.personalInfoAPI, requestData);
    // }
    // public getRequestApprovedAPI = (requestData: any,): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.getRequestApprovedAPI, requestData);
    // }
    // public CDMNupdateValidationAPI = (requestData: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.CDMNupdateValidationAPI, requestData);
    // }
    // public suspendTeacherAPI = (filterData: any): Observable<any> => {
    //     return this.httpClient.post<any>(this.apiUrl.groupApiUrl.suspendTeacherAPI, filterData);
    // }


}
